import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';

export interface TruncatedTextProps {
  value?: string | null;
  maxLength?: number;
  emptyHolder?: string;
}

export const TruncatedText: React.FC<TruncatedTextProps> = ({
  value,
  maxLength = 50,
  emptyHolder = '-',
}) => {
  const { t } = useTranslations();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!value) {
    return <Typography variant="body2">{emptyHolder}</Typography>;
  }

  const shouldTruncate = value.length > maxLength;
  const displayedText =
    shouldTruncate && !isExpanded ? `${value.slice(0, maxLength)}...` : value;

  return (
    <Box sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
      <Typography variant="body2" component="span">
        {displayedText}
      </Typography>
      {shouldTruncate && (
        <Button
          size="small"
          onClick={() => setIsExpanded((prev) => !prev)}
          sx={{
            ml: 1,
            textTransform: 'none',
            p: 0,
            minWidth: 'auto',
            verticalAlign: 'baseline',
          }}
        >
          {isExpanded ? t('general.showLess.button') : t('general.showMore.button')}
        </Button>
      )}
    </Box>
  );
};
